import React from 'react';
import { eClientContactActionType } from 'types/contacts/eClientContactActionType';
import { IFetchStatus } from 'types/rest/IFetchStatus';
import { SwitchDialogWindows } from 'ui-toolkit';
import { ContactActionConfirmationWindow } from './ContactActionConfirmationWindow';
import { GetContactSuccessMessage } from './GetContactSuccessMessage';

export interface IContactActionDialogProps {
  onDone: () => void;
  onReset: () => void;
  onAction: () => void;
  fetchStatus: IFetchStatus;
  fetchError?: Error;
  email: string;
  name: string;
  actionType: eClientContactActionType;
}

export const ContactActionDialog: React.FC<IContactActionDialogProps> = ({
  onDone,
  onReset,
  onAction,
  fetchStatus,
  fetchError,
  email,
  name,
  actionType,
}) => (
  <SwitchDialogWindows
    onCloseClick={() => {
      onDone();
      onReset();
    }}
    onRetryClick={() => onAction()}
    isError={!!fetchError}
    isLoading={fetchStatus.fetching}
    isCompleted={fetchStatus.fetched}
    errorTitle={fetchError && fetchError.message}
    successTitle={<GetContactSuccessMessage actionType={actionType} email={email} />}
  >
    <ContactActionConfirmationWindow
      type={actionType}
      userName={name}
      onNoClick={() => onDone()}
      onYesClick={() => onAction()}
    />
  </SwitchDialogWindows>
);
